import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { createLegacyCanopyLink } from 'utils/links'

import { ReactComponent as IconCheckDropdown } from 'assets/icons/IconCheckDropdown.svg'
import { ReactComponent as IconArrowLink } from 'assets/icons/IconArrowLink.svg'
import { ReactComponent as IconArrowDown } from 'assets/icons/IconArrowDown.svg'

const Dropdown = (props) => {
  const {
    className,
    label,
    options,
    selectedOption,
    handleClick,
    showDropdownMenu,
    setShowDropdownMenu,
  } = props

  const dropdownRef = useRef(null)
  const userAccountIconRef = useRef(null)

  useEffect(() => {
    const hideElement = (e) => {
      if (dropdownRef.current.contains(e.target) || userAccountIconRef.current.contains(e.target)) {
        return
      }

      setShowDropdownMenu(false)
    }

    if (showDropdownMenu) {
      document.addEventListener('click', hideElement)
    } else {
      document.removeEventListener('click', hideElement)
    }
    return () => {
      document.removeEventListener('click', hideElement)
    }
  }, [showDropdownMenu, setShowDropdownMenu])

  const dropdownClasses = cn(['dropdown', className], {
    '-open': showDropdownMenu,
  })

  const toggleDropdownMenu = () => {
    setShowDropdownMenu(!showDropdownMenu)
  }

  const onOptionClick = (id) => {
    handleClick(id)
  }

  const renderDropdownMenu = () => (
    <div className="dropdown__inner-wrapper" ref={dropdownRef}>
      <ul className="dropdown__list">
        {options.map(({ value, label }) => (
          <li className="dropdown__list-item" key={value}>
            <button className="dropdown__link-button" onClick={() => onOptionClick(value)}>
              {label}
              {selectedOption === value && <IconCheckDropdown />}
            </button>
          </li>
        ))}
        <li className="dropdown__list-item">
          <button
            className="dropdown__link-button"
            onClick={() => {
              window.location.href = createLegacyCanopyLink()
            }}
          >
            Canopy Classic
            <IconArrowLink />
          </button>
        </li>
      </ul>
    </div>
  )
  return (
    <div className={dropdownClasses}>
      <span className="dropdown__title">{label}</span>
      <button className="dropdown__user-icon" onClick={toggleDropdownMenu} ref={userAccountIconRef}>
        <IconArrowDown />
      </button>
      {showDropdownMenu && renderDropdownMenu()}
    </div>
  )
}

Dropdown.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedOption: PropTypes.string,
  handleClick: PropTypes.func,
  showDropdownMenu: PropTypes.bool,
  setShowDropdownMenu: PropTypes.func,
}

Dropdown.defaultProps = {
  className: '',
  label: '',
  selectedOption: '',
  handleClick: () => {},
}

export default Dropdown
